export default "/images/ac39aeecdf841fcd03d5a5a1cc458e79.avif";